import * as React from 'react';
import Expander_helper from './Expander_helper'


interface MyProps {
    tup:any
}
type MyState = {
}

class DerivedValueStep extends React.PureComponent<MyProps,MyState> {
    constructor(props: MyProps) {
        super(props)
    }
    render(){
	let tup = this.props.tup
	    let exp = new Expander_helper();

	return (
	    <div className="step with-expand collapsed">
		<div className="header"  onClick={exp.toggle_expand}>
		    <div className="pre-icon"></div>
		    <div className="label"><b>{tup.label} </b></div>
		</div>
		<div className="body">
		  <div className="label value"> {tup.value}</div>
		</div>
	    </div>
	)
	
    }
}
export default DerivedValueStep
